import React from 'react'
import Layout from '../components/layout'
import Previousmatchesall from '../components/wt/previousmatchesall'




const Previousmatches = () => (
    <Layout>
        <Previousmatchesall />
    </Layout>

)

export default Previousmatches